import { getDataWithParams } from "../helpers/apiHelper2";
import { getDataWithParams as getDataWithParamsV3 } from "../helpers/apiHelperV3";
import { AsianStatementTabTypes as TabTypes } from "../utils/const";
import { urls } from "./urls";

import type { Pagination } from "app/types/paginateType";

const API_REPORTS = "/eurasian/statement/reports/";

/**
 * Fetch Asian statement summary list from API v3
 */
export interface FetchStatementSummaryListPayload extends Pagination {
  tab: TabTypes;
  after?: string;
  before?: string;
  sportId?: number;
  filter?: string;
}

export const fetchStatementSummaryList = async (
  payload: FetchStatementSummaryListPayload
): Promise<any> => {
  let url: string = urls.reports.API_REPORTS_ALL();

  if (payload.tab === TabTypes.BETTING) {
    url = urls.reports.API_REPORTS_BETS();
  } else if (payload.tab === TabTypes.FUNDING) {
    url = urls.reports.API_REPORTS_FUNDING();
  }

  const params: Record<string, unknown> = {};
  params["page"] = payload && payload.page;
  params["size"] = payload && payload.size;
  params["after"] = payload && payload.after;
  params["before"] = payload && payload.before;
  params["sportId"] = payload && payload.sportId;
  params["filter"] = payload && payload.filter;

  return getDataWithParamsV3(url, params);
};

/**
 * Fetch Asian statement normal list from API v3
 */

export interface FetchStatementNormalPayload extends Pagination {
  tab: TabTypes;
  after?: string;
  before?: string;
  runnerId?: number;
  leagueId?: number;
  participant?: string;
}

export const fetchStatementNormalList = (
  payload: FetchStatementNormalPayload
): Promise<any> => {
  let url: string = urls.reports.API_REPORTS_BETS_BY_DATE();

  if (payload.tab !== TabTypes.FUNDING) {
    if (payload.runnerId) {
      url = urls.reports.API_REPORTS_BETS_BY_DATE(payload.runnerId);
    } else if (payload.leagueId) {
      url = url = urls.reports.API_REPORTS_BETS_BY_LEAGUE(payload.leagueId);
    } else {
      url = urls.reports.API_REPORTS_BETS_BY_DATE();
    }
  } else if (payload.tab === TabTypes.FUNDING) {
    url = urls.reports.API_REPORTS_FUNDING_BY_DATE();
  }
  const params: Record<string, unknown> = {};
  params["page"] = payload && payload.page;
  params["size"] = payload && payload.size;
  params["before"] = payload && payload.before;
  params["after"] = payload && payload.after;

  if (payload.participant) {
    params["participant"] = payload.participant;
  }

  return getDataWithParamsV3(url, params);
};

/**
 * fetch asian statement League list from API v3
 */

export interface FetchStatementLeagueListPayload extends Pagination {
  tab: TabTypes;
  after?: string;
  before?: string;
  competitionName?: string;
}

export const fetchStatementLeagueList = (
  payload: FetchStatementLeagueListPayload
): Promise<any> => {
  let url = urls.reports.API_REPORTS_BETS_BY_LEAGUE();

  const params: Record<string, unknown> = {};
  params["page"] = payload && payload.page;
  params["size"] = payload && payload.size;
  params["before"] = payload && payload.before;
  params["after"] = payload && payload.after;

  if (payload.competitionName) {
    params["competitionName"] = payload.competitionName;
  }

  return getDataWithParamsV3(url, params);
};

/**
 * fetch asian statement Match list from API v3
 */

export interface FetchStatementMatchListPayload extends Pagination {
  tab: TabTypes;
  after?: string;
  before?: string;
  eventName?: string;
}

export const fetchStatementMatchList = (
  payload: FetchStatementMatchListPayload
): any => {
  let url = urls.reports.API_REPORTS_BETS_BY_EVENT();

  const params: Record<string, unknown> = {};
  params["page"] = payload && payload.page;
  params["size"] = payload && payload.size;
  params["before"] = payload && payload.before;
  params["after"] = payload && payload.after;

  if (payload.eventName) {
    params["eventName"] = payload.eventName;
  }

  return getDataWithParamsV3(url, params);
};

/**
 * fetch asian statement normal list from API v3
 */

export interface FetchStatementFundingListPayload extends Pagination {
  tab: TabTypes;
  after?: string;
  before?: string;
  participant?: string;
}

export const fetchStatementFundingList = (payload: any): any => {
  const url = urls.reports.API_REPORTS_FUNDING_BY_DATE();

  const params: Record<string, unknown> = {};
  params["page"] = payload && payload.page;
  params["size"] = payload && payload.size;
  params["before"] = payload && payload.before;
  params["after"] = payload && payload.after;

  if (payload.participant) {
    params["participant"] = payload.participant;
  }

  return getDataWithParamsV3(url, params);
};

/**
 * fetch statement exchange markets
 */
export const fetchStatementExchangeMarkets = (payload: any): any => {
  const url = API_REPORTS + "exchange-markets-by-date";

  const params = {};
  params["before"] = payload && payload.before;
  params["after"] = payload && payload.after;

  if (payload.filter) {
    params["participant"] = payload.filter; // Needs api change to work
  }

  return getDataWithParams(url, params);
};

/**
 * fetch statement exchange bets
 */
export const fetchStatementExchangeBetsPerMarket = (payload: any): any => {
  const url = `${API_REPORTS}exchange-bets/${payload.marketId}`;
  const params = {};

  if (payload.filter) {
    params["participant"] = payload.filter; // Needs api change to work
  }
  return getDataWithParams(url, params);
};
